/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../../shared/ModalBodyLayout';
import { manageCardScreens } from '../constants';

import { useUserCountry, useUserDefaultCardCurrency } from '../../../utilities/sharedHooks/user';

import { useSetting } from '../../../utilities/sharedHooks/settings';

import TransferFees from './TransferFees';
import AccountFees from './AccountFees';
import ContactInfo from './ContactInfo';

const CardFees = ({ openScreen, cardProvider }) => {
  const { t: translate } = useTranslation();
  const { defaultCardCurrency } = useUserDefaultCardCurrency();

  const userCountry = useUserCountry();

  const [monthlyPurchaseFee] = useSetting('card_fees', `card_fee_${cardProvider}_monthly_purchase`);
  const [withdrawalNetworkFee] = useSetting(
    'card_fees',
    `card_fee_${cardProvider}_withdrawal_network`
  );
  const [conversionFee] = useSetting('card_fees', `card_fee_${cardProvider}_conversion`);
  const [retailLoadFee] = useSetting('card_fees', `card_fee_${cardProvider}_retail_load`);
  const [inactivityFee] = useSetting('card_fees', `card_fee_${cardProvider}_inactivity`);
  const [closeFee] = useSetting('card_fees', `card_fee_${cardProvider}_close`);
  const [replacementFee] = useSetting('card_fees', `card_fee_${cardProvider}_replacement`);
  const [cryptoToFiatFee] = useSetting('card_fees', `card_fee_${cardProvider}_crypto_to_fiat`);
  const [expeditedReplacementFee] = useSetting(
    'card_fees',
    `card_fee_${cardProvider}_expedited_replacement`
  );

  const canRenderContent = useMemo(
    () => defaultCardCurrency && userCountry,
    [defaultCardCurrency, userCountry]
  );

  return (
    <ModalBodyLayout
      title={translate('manage_card_setting_option_card_fees_title_modal')}
      onPrevClick={() => openScreen(manageCardScreens.MAIN)}
      withBack
      isButtonInFooter
      isScrollbarHidden>
      {canRenderContent && (
        <div className="d-flex flex-column flex-fill mt-4">
          <TransferFees
            userCurrency={defaultCardCurrency}
            conversionFee={conversionFee || 3}
            monthlyPurchaseFee={monthlyPurchaseFee || 0}
            withdrawalNetworkFee={withdrawalNetworkFee || 2.5}
            cryptoToFiatFee={cryptoToFiatFee || 2}
          />
          <AccountFees
            userCurrency={defaultCardCurrency}
            retailLoadFee={retailLoadFee || 5}
            inactivityFee={inactivityFee || 5}
            closeFee={closeFee || 0}
            replacementFee={replacementFee || 10}
            expeditedReplacementFee={expeditedReplacementFee || 30}
          />
          <ContactInfo userCountry={userCountry} />
        </div>
      )}
    </ModalBodyLayout>
  );
};

CardFees.propTypes = {
  openScreen: PropTypes.func.isRequired,
  cardProvider: PropTypes.string.isRequired,
};

export default CardFees;
